/* VulkanUS · Designsystem v2 — Verhalten  ·  24.09.2026
   Einmal global geladen (defer). Alles ist optional: Fehlt JS, zeigt das CSS
   nach spätestens 4 s alle Inhalte (Failsafe in vk2.css). */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- 1) Scroll-Reveal ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll('[data-v2-reveal]:not(.is-in)');
    if (!els.length) return;
    if (!hasIO || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- 2) Wort-Reveal beim Scrollen (Apple-Statement) ---------- */
  var wordBlocks = [];
  function initWords(root) {
    root.querySelectorAll('[data-v2-words]:not([data-v2-words-ready])').forEach(function (el) {
      el.setAttribute('data-v2-words-ready', '');
      if (reduce) return;
      // Nur Textknoten zerlegen, Inline-Elemente (b, em, span) bleiben erhalten.
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (n) {
        var parts = n.nodeValue.split(/(\s+)/); var frag = document.createDocumentFragment();
        parts.forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
          var s = document.createElement('span'); s.className = 'w'; s.textContent = p; frag.appendChild(s);
        });
        n.parentNode.replaceChild(frag, n);
      });
      wordBlocks.push({ el: el, words: el.querySelectorAll('.w') });
    });
  }
  function tickWords() {
    var vh = window.innerHeight;
    wordBlocks.forEach(function (b) {
      var r = b.el.getBoundingClientRect();
      // Fortschritt: beginnt, wenn die Oberkante bei 85 % steht, fertig bei 35 %.
      var p = (vh * 0.85 - r.top) / (vh * 0.5 + r.height * 0.6);
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * b.words.length);
      for (var i = 0; i < b.words.length; i++) b.words[i].classList.toggle('on', i < n);
    });
  }

  /* ---------- 3) Sticky-Story (Bild bleibt stehen, Text wechselt) ---------- */
  var stories = [];
  function initStories(root) {
    root.querySelectorAll('[data-v2-story]:not([data-v2-story-ready])').forEach(function (el) {
      el.setAttribute('data-v2-story-ready', '');
      stories.push({ el: el, steps: el.querySelectorAll('[data-v2-step]'), imgs: el.querySelectorAll('[data-v2-shot]'), dots: el.querySelectorAll('[data-v2-dot]'), cur: -1 });
    });
  }
  function storyActive(el) { return window.innerWidth >= 900 && !reduce && getComputedStyle(el).getPropertyValue('--v2-story-on').trim() === '1'; }
  function tickStories() {
    var vh = window.innerHeight;
    stories.forEach(function (s) {
      if (!storyActive(s.el)) return;
      var r = s.el.getBoundingClientRect();
      var total = r.height - vh; if (total <= 0) return;
      var p = Math.max(0, Math.min(1, -r.top / total));
      var n = s.steps.length; var f = p * (n - 1);            // 0 … n-1, kontinuierlich
      var idx = Math.min(n - 1, Math.round(f));
      // Bilder: Bild i+1 wird von unten „aufgewischt“ und zoomt von 1.18 auf 1.06
      for (var i = 0; i < s.imgs.length; i++) {
        var local = Math.max(0, Math.min(1, f - (i - 1)));     // 0→1 während Übergang zu Bild i
        var img = s.imgs[i];
        if (i === 0) { img.style.clipPath = 'inset(0 0 0 0)'; img.style.transform = 'scale(' + (1.06 + 0.04 * Math.max(0, Math.min(1, f))) + ')'; continue; }
        var e = local < 1 ? local * local * (3 - 2 * local) : 1;
        img.style.clipPath = 'inset(' + ((1 - e) * 100).toFixed(2) + '% 0 0 0)';
        img.style.transform = 'scale(' + (1.18 - 0.12 * e).toFixed(4) + ')';
      }
      if (idx !== s.cur) {
        s.steps.forEach(function (st, i) { st.classList.toggle('is-active', i === idx); });
        s.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        s.cur = idx;
      }
    });
  }

  /* ---------- 4) Ambient (Lichtreflex / Späne) nur im sichtbaren Bereich ---------- */
  function initAmbient(root) {
    root.querySelectorAll('.v2-amb:not([data-v2-amb-ready])').forEach(function (el) {
      el.setAttribute('data-v2-amb-ready', '');
      if (el.classList.contains('v2-amb--chips')) {
        var n = window.innerWidth < 750 ? 9 : 16;
        for (var i = 0; i < n; i++) {
          var c = document.createElement('i');
          c.style.left = (8 + Math.random() * 90).toFixed(1) + '%';
          c.style.animationDelay = (Math.random() * 9).toFixed(2) + 's';
          c.style.animationDuration = (7 + Math.random() * 5).toFixed(2) + 's';
          c.style.height = (12 + Math.random() * 16).toFixed(0) + 'px';
          c.style.width = (1.5 + Math.random() * 1.2).toFixed(1) + 'px';
          el.appendChild(c);
        }
      }
      if (!hasIO) { el.classList.add('is-in'); return; }
      new IntersectionObserver(function (en) { en.forEach(function (x) { x.target.classList.toggle('is-in', x.isIntersecting); }); }, { threshold: 0.05 }).observe(el);
    });
  }

  /* ---------- 4b) Videos: Lazy-Load + nur im Bild abspielen ----------
     Sektionsvideos tragen ihre Quelle als data-v2-src und bekommen src erst,
     wenn sie ins Bild kommen. Zwei Gründe:
     1) Tempo: Die Startseite lud sonst beim Öffnen alle Videos (je bis zu 3 MB).
     2) Chrome pausiert vorab geladene Autoplay-Videos außerhalb des Bildes und
        zeichnet sie danach teils nicht mehr (Kachel blieb schwarz/grau, obwohl
        das Video lief). Ein erst im Bild gesetztes src rendert zuverlässig.
     Danach: im Bild play(), außerhalb pause() — spart am Handy Akku und Daten.
     Videos mit echtem autoplay-Attribut (Hero, oben im Bild) laufen wie gehabt,
     werden aber ebenfalls außerhalb des Bildes pausiert.
     13.10.2026 (Pauls Wunsch): Lazy-Videos starten erst, wenn sie zu mind. 40 % sichtbar
     sind, und IMMER bei Sekunde 0 (auch nach dem Wegscrollen und Zurückkommen). Die Quelle
     wird 600 px vorher geladen, damit der Start ohne Ruckeln gelingt. */
  function initVideos(root) {
    root.querySelectorAll('.v2 video[data-v2-src]:not([data-v2-vid]), .v2 video[autoplay]:not([data-v2-vid])').forEach(function (v) {
      v.setAttribute('data-v2-vid', ''); v.muted = true;
      var lazy = v.getAttribute('data-v2-src');
      if (reduce) { if (!lazy) v.pause(); return; }          // reduzierte Bewegung: nur Poster
      if (!hasIO) { if (lazy) { v.src = lazy; v.play(); } return; }
      if (lazy) {
        var shown = false;
        new IntersectionObserver(function (en) {
          en.forEach(function (x) {
            if (x.isIntersecting && !v.getAttribute('src')) { v.preload = 'auto'; v.src = lazy; }
          });
        }, { rootMargin: '600px 0px', threshold: 0 }).observe(v);
        new IntersectionObserver(function (en) {
          en.forEach(function (x) {
            var vid = x.target;
            var enough = x.isIntersecting && (x.intersectionRatio >= 0.4 || x.intersectionRect.height >= window.innerHeight * 0.5);
            if (enough) {
              if (!vid.getAttribute('src')) { vid.preload = 'auto'; vid.src = lazy; }
              if (!shown) { shown = true; try { vid.currentTime = 0; } catch (e) {} }
              var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
            } else if (!x.isIntersecting) {
              shown = false;
              if (!vid.paused) vid.pause();
            }
          });
        }, { threshold: [0, 0.2, 0.4, 0.6, 0.8, 1] }).observe(v);
        return;
      }
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          var vid = x.target, ds = vid.getAttribute('data-v2-src');
          if (x.isIntersecting) {
            if (ds && !vid.getAttribute('src')) { vid.src = ds; }
            var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
          } else if (!vid.paused) vid.pause();
        });
      }, { rootMargin: '200px 0px', threshold: 0.01 }).observe(v);
    });
  }

  /* ---------- 5) Horizontale Karussells: Pfeile ---------- */
  function initRails(root) {
    root.querySelectorAll('[data-v2-rail]:not([data-v2-rail-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-v2-rail-ready', '');
      var track = wrap.querySelector('.v2-scroll-x'); if (!track) return;
      var prev = wrap.querySelector('[data-v2-prev]'), next = wrap.querySelector('[data-v2-next]');
      function step(dir) { var c = track.firstElementChild; var w = c ? c.getBoundingClientRect().width + 16 : 320; track.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' }); }
      function upd() { if (prev) prev.disabled = track.scrollLeft < 8; if (next) next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8; }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', upd, { passive: true }); upd();
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { tickWords(); tickStories(); ticking = false; });
  }

  function init(root) {
    root = root || document;
    initReveal(root); initWords(root); initStories(root); initAmbient(root); initVideos(root); initRails(root);
    onScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Horizon scrollt ab 990 px nicht das Fenster, sondern .page-wrapper (base.css:
  // html:has(.page-wrapper){overflow:hidden}). Scroll-Ereignisse blubbern nicht —
  // deshalb in der Capture-Phase am document lauschen, das fängt beide Fälle.
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll);
  // Theme-Editor: neu gerenderte Sektionen initialisieren
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.VK2 = { init: init };
})();
